import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";

// AmplifyJS complains in the event that the browser storage is empty,
// which it may be in incognito mode, upon creation of a new browser user
// profile, and under other conditions. Here we set an arbitrary unique id
// for the session which ensures that storage is never entirely empty.
if (!localStorage.getItem("revanista-app-session-meta")) {
  localStorage.setItem(
    "revanista-app-session-meta",
    JSON.stringify({ id: crypto.randomUUID() }),
  );
}

export const config = Amplify.configure(
  {
    Auth: {
      Cognito: {
        userPoolId: import.meta.env.VITE_REACT_APP_COGNITO_USER_POOL_ID ?? "",
        identityPoolId:
          import.meta.env.VITE_REACT_APP_COGNITO_IDENTITY_POOL_ID ?? "",
        userPoolClientId:
          import.meta.env.VITE_REACT_APP_COGNITO_WEB_CLIENT_ID ?? "",
      },
    },
    API: {
      REST: {
        yield: {
          endpoint: import.meta.env.VITE_REACT_APP_YIELD_API_URL ?? "",
        },
        yieldV2: {
          endpoint: import.meta.env.VITE_REACT_APP_YIELD_V2_API_URL ?? "",
        },
        "yield-v2": {
          endpoint: import.meta.env.VITE_REACT_APP_YIELD_V2_API_URL ?? "",
        },
        ota: {
          endpoint: import.meta.env.VITE_REACT_APP_OTA_API_URL ?? "",
        },
        config: {
          endpoint: import.meta.env.VITE_REACT_APP_CONFIG_API_URL ?? "",
        },
      },
    },
  },
  {
    API: {
      REST: {
        headers: async () => {
          return {
            Authorization: await getJwtToken(),
          };
        },
      },
    },
  },
);

async function getJwtToken(): Promise<string> {
  const session = await fetchAuthSession();
  return session.tokens?.idToken ? session.tokens?.idToken.toString() : "";
}
